import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_REVIEW_COMPLETE: NotificationConfiguration = {
  inapp: `All reviewers have now submitted their meeting minutes reviews.`,
  email: {
    ctaKey: 'go_to_meeting_minutes',
  },
};
